// extracted by mini-css-extract-plugin
export default {"container":"seifaN","panel":"ULlblj","panel-description":"v_jYc2"};